// src/stone/icons/DollarPhone.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarPhone = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM3.879.879A3 3 0 0 1 6 0h12a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V3A3 3 0 0 1 3.879.879" }),
      /* @__PURE__ */ jsx("path", { d: "M13 4v16h-2V4z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.332 5.493c1.642-.118 3.521.298 4.525.85l.876.481-.963 1.753-.877-.482c-.617-.34-2.102-.701-3.418-.607-.65.047-1.133.197-1.428.405-.24.17-.399.4-.399.839 0 .551.212.878.604 1.166.461.337 1.118.578 1.954.857l.179.06c.727.24 1.593.527 2.276.966.81.522 1.471 1.33 1.471 2.57 0 1.048-.35 1.916-1.017 2.546-.64.605-1.477.902-2.306 1.027-1.643.246-3.603-.128-5.147-.683l-.941-.338.676-1.882.941.338c1.374.494 2.98.766 4.174.587.589-.089.987-.274 1.229-.502.215-.203.391-.52.391-1.093 0-.382-.149-.627-.555-.888-.46-.297-1.094-.508-1.912-.78l-.091-.03c-.785-.262-1.749-.589-2.504-1.142-.823-.604-1.422-1.493-1.422-2.779 0-1.096.48-1.933 1.247-2.474.713-.503 1.608-.705 2.437-.765" })
    ]
  }
);
var DollarPhone_default = DollarPhone;

export {
  DollarPhone,
  DollarPhone_default
};
